<div class="primary pad-L">
	<div style="min-height: 278px; overflow: auto">
		<div class="flex-align-center gap-S f-d-r mb-m">
			<app-chips [square]="true" [size]="'xl'">
				<img src="assets/icons/layers-three-02.svg" class="filter-grey" height="25px">
			</app-chips>
			<div class="flex-column gap-XS ml-s">
				<div class="font-L fw-700">{{ 'page.appDetails.overview.functionalCapacities.editCapacity' | translate }}</div>
				<div class="font-M fw-300">{{ 'page.appDetails.overview.functionalCapacities.addSubtitle' | translate }}</div>
			</div>
		</div>
		<div class="flex-column gap-L">
			<form class="flex-column gap-L" [formGroup]="editFunctionalCapacityGroupForm">
				<div class="flex-column gap-XS overflow-hidden">
					<div class="font-M fw-500 grey">{{ 'page.appDetails.overview.functionalCapacities.groupName' | translate }}*</div>
					<app-text-input [input]="$any(editFunctionalCapacityGroupForm.get('name'))"
									[placeholder]="'page.appDetails.overview.functionalCapacities.nameInput' | translate"></app-text-input>
				</div>
			</form>
		</div>
	</div>
	<div class="w-100 disp-f f-d-r j-c-sb a-i-c mt-l gap-M">
		<app-text-button class="w-50" type="stroked" (click)="onCancel()">{{ 'page.appDetails.overview.functionalCapacities.back' | translate }}</app-text-button>
		<app-text-button class="w-50" type="flat" (click)="onSave()" [disabled]="!editFunctionalCapacityGroupForm.valid">{{ 'button.save' | translate }}</app-text-button>
	</div>
</div>
